// 15-July-25
import React from 'react'
import Select from "react-select";
import { DatePicker, Label, PrimaryButton, TextField } from "@fluentui/react";
import { customStyles, onFormatDate, SelectTheme } from './Global/Constant';
import { fetchRequestData, fetchRequestListData, getGeneralData, getFileById, updateListItem, getDraftVersionHistory, handleTokenExpiration } from '../Utils/CommonFunctions';
import ContextService from '../services/ContextService';
import axios from "axios";
import { LayerRegular,CommentAdd20Regular, Save24Regular, TaskListLtr24Regular  } from '@fluentui/react-icons';
import './Home.css';
import Terms from './Terms';
import AlternateClauseAI from './AlternateClauseAI';
import MissingClauseExtractor from './MissingClause';
import { SweetAlerts } from './Global/SweetAlert';
import ClauseSummary from './ClauseSummary';
import SendReview from './Send Review/SendReview';
import {  Modal, Spinner, SpinnerSize } from 'office-ui-fabric-react';
import moment from 'moment';
import ContractSummary from './ContractSummary';
let allRequestItems = [];
let draftFileName="";
let allTasksRequest=[];
let AllTaskType=[]
let RequestActions=[]
let LatestDraftversions;
function EditDraft({setIsTermsDetailsListOpen,setShow,show,setIsAlterNativeClauseOpen,setIsMissingClauseOpen,setIsSummaryOpen,setIsAISummary}) {
    const AiStars : any = require("../../../assets/AiStars.png")
    const FileName=localStorage.getItem('DraftFileName')
    // console.log(FileName,'Draft File Called',show)
    const JSZip=require("jszip")
    const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI")||"{}")
    const Copilot:any= JSON.parse(localStorage.getItem("Copilot")||"{}")
    const [allRequestOpt, setAllRequestOpt] = React.useState([]);
    const [selectedRequest, setSelectedRequest] = React.useState(undefined);
    const [spinnerLoading, setspinnerLoading] = React.useState(false);
    const [isAIEnabled, setisAIEnabled] = React.useState(false);
    const [data,setData]=React.useState<any>({})
    const [RequestLoading, setRequestLoading] = React.useState(false);
    const [requestDetails,setRequestDetails] = React.useState(null);
    const [selectedRequestData,setSelectedRequestData] = React.useState(null);
    const [selectedthirdFile,setselectedthirdFile] = React.useState(null);
    const [isSendReview, setisSendReview] = React.useState(false);
    const [draftInLegalReview, setDraftInLegalReview] = React.useState(false);
    const {SweetAlert:SweetAlertsEdit, SweetPrompt:SweetalertPrompt } = SweetAlerts("#SweetalertEditDraftss");
    const [keyValuePair, setKeyValuePair] = React.useState({});
    const [ShowAllReq, setShowAllReq] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [summaryState, setSummaryState] = React.useState({
         summary: "",
         isLoading: true,
       });
    const CurrentUser = JSON.parse(localStorage.getItem('CurrentAppUser'))
    
  const transformOrgInfo = (orgInfo) => {
  return {
    Organization_Address_Line_1: orgInfo.Address1 || "-",
    Organization_Address_Line_2: orgInfo.Address2 || "-",
    Organization_City: orgInfo.City || "-",
    Organization_Contact_Number: orgInfo.ContactNumber || "-",
    Organization_Country: orgInfo.Country || "-",
    Organization_Currency: orgInfo.Currency || "-",
    Organization_Jurisdiction: orgInfo.OrganizationJurisdiction || "-",
    Organization_State: orgInfo.State || "-",
    Organization_Title: orgInfo.OrganizationTitle || "-",
    Organization_URL: orgInfo.OrganizationURL || "-",
    Organization_Website: orgInfo.Website || "-",
    Organization_Zip_Code: orgInfo.ZipCode ? orgInfo.ZipCode : "-",
  };
};
const transformBusinessUnit = (Businessunit) => {
  const businessUnitArray = Array.isArray(Businessunit) ? Businessunit : [Businessunit];
  const finalUnit = businessUnitArray.find(i => i.Guid === requestDetails?.['Business_Unit'] || i.GUID === requestDetails?.['Business_Unit']);
  return {
    Business_Unit: finalUnit ? finalUnit.Name : "-",
  };
};
const counterpartyArray = JSON.parse(requestDetails?.['Counterparty_Name'] || "[]");
const Counterparty = {
  key: counterpartyArray.map(i => i?.key).join(', ') || "-",
  Counterparty_Type: counterpartyArray.map(i => i?.Counterpartyname).join(', ') || "-",
  Organization_Name: counterpartyArray.map(i => i?.OrgName).join(', ') || "-",
  Counterparty_Name: counterpartyArray.map(i => i?.OrgName).join(', ') || "-",
  Country: counterpartyArray.map(i => i?.Country).join(', ') || "-",
  State: counterpartyArray.map(i => i?.State).join(', ') || "-",
  City: counterpartyArray.map(i => i?.City).join(', ') || "-",
  Zip_Code: counterpartyArray.map(i => i?.ZipCode).filter(Boolean).join(', ') || "-",
  Address_Line_1: counterpartyArray.map(i => i?.Address_Line_1).filter(Boolean).join(', ') || "-",
  Address_Line_2: counterpartyArray.map(i => i?.Address_Line_2).filter(Boolean).join(', ') || "-",
  Contact_Number: counterpartyArray.map(i => i?.Contact_Number).join(', ') || "-",
  Email: counterpartyArray.map(i => i?.email).join(', ') || "-",
  Counterparty_Jurisdiction: counterpartyArray.map(i => i?.OrganizationJurisdiction).join(', ') || "-",
  Guid_ID: counterpartyArray.map(i => i?.Guid_ID).join(', ') || "-",
  Contract_Type:requestDetails?.['ActualFileName']?.replace(/\.[^/.]+$/, ""),
};
const requestFields = [
  { label: "Title", value: keyValuePair?.['Title'] },
  { label: "Request Number", value: keyValuePair?.['Request_Number'] },
  { label: "Business Unit", value: keyValuePair?.['Business_Unit'] },
  { label: "Contract Type", value: keyValuePair?.['Contract_Type'] },
  { label: "Counterparty", value: keyValuePair?.['Counterparty_Name'] },
  { label: "Start Date", value: keyValuePair?.['Contract_Start_Date']},
  { label: "End Date", value: keyValuePair?.['Contract_End_Date']},
]
React.useEffect(() => {
  const fetchData = async () => {
    try {
      const data = await getGeneralData();
      RequestActions = JSON.parse(data?.value[0]?.RequestActions||"[]");
      const parsedOrgInfo = JSON.parse(data?.value[0]?.OrganizationInfo || "[]")[0] || {};
      const parsedBusinessUnit = JSON.parse(data?.value[0]?.BusinessUnit || "[]")[0] || {};
      const OrganizationInfo = transformOrgInfo(parsedOrgInfo);
      const BusinessUnit = transformBusinessUnit(parsedBusinessUnit);
      setKeyValuePair({ ...OrganizationInfo, ...requestDetails, ...Counterparty, ...BusinessUnit});
      if(requestDetails?.File_Name){
        LatestDraftversions = await getDraftVersionHistory(requestDetails?.File_Name);
      }
    } catch (error) {
      console.error("Error fetching general data:", error);
    }
  };

  fetchData();
 if(AzureAI?.Endpoint && AzureAI?.DeploymentName && AzureAI?.APIkey && AzureAI?.AzureOpenAIToggle || Copilot?.CopilotToggle ==='Yes'){
  setisAIEnabled(true)
 }
}, [requestDetails]);
 const replaceFieldValues = async () => {
     try {
       await Word.run(async (context) => {
         let contentControls = context.document.contentControls;
         contentControls.load("items, tag");
         await context.sync();
        //  console.log(contentControls.items);
         contentControls.items.forEach((control) => {
           let fieldName = control.tag;
           let fieldValue = fieldName === "Contract_Cost" ? JSON.parse(keyValuePair?.[fieldName])?.settingsAmount :
           /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/?.test(keyValuePair[fieldName]) ?
           moment(keyValuePair[fieldName])?.format('MM/DD/YYYY') :
           (keyValuePair[fieldName] && keyValuePair[fieldName]?.toString()?.trim()) ? keyValuePair[fieldName] : "-";
           // if (keyValuePair[fieldName]) {
           control.insertText(fieldValue?.toString(), Word.InsertLocation.replace);
          //  console.log(fieldValue);
          //  console.log(control);
           // }
         });
         await context.sync();
       });
     } catch (error) {
       console.log(error, "Erro Found");
     }
   };

    React.useEffect(() => {
      // console.log(FileName,'Draft File Outside')
      if (allRequestOpt?.length > 0&&FileName) {
        // console.log(FileName,'Draft File Inside')
          const defaultRequest = allRequestOpt.find(req => req?.File_Name === FileName);
          if (defaultRequest) {
              onChangeRequest(defaultRequest,'Application');
          }
          setShow({ Terms:false, alternat:false, missingClause:false})
      }

  }, [FileName,allRequestOpt]);
    const onChangeRequest=async (item,Process)=>{
        if (item) {
            setData({})
            setSelectedRequest(item.key as string);
            setRequestDetails(item);
            await getRequestData(item.key);
            localStorage.setItem("DraftFileName",item?.File_Name)
            const { ServerRelativeUrl } = await getFileById(item?.File_Name);
             draftFileName=item?.File_Name;
            //  const allTasks=await fetchTaskRequestData(item.key);
            //  AllTaskType=allTasks?.map(task=>task?.LevelStage)||[]
            await getText(ServerRelativeUrl,Process)
          }
    }

    React.useEffect(() => {
        getAllRequestData();
      }, []);

      async function getText(ServerRelativeUrl,Process){
        const filePath = encodeURIComponent(ServerRelativeUrl);
        const curl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${filePath}')/$value`;
        try{
          const token = localStorage.getItem("CurrentToken");
          const responseBlob:any= await axios({
            method: 'get',
            url: curl,
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            responseType: 'blob'
          })
     
           if(responseBlob?.data){
              const fileData = new File([responseBlob?.data], "template.docx", {
              type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            });
            // selectedthirdFile = file;
            setselectedthirdFile(fileData)
            if(Process=="Select"){
              await insertFileIntoWord(fileData);
            }
             
          }
        }catch(error){
          console.log(error)
        }    
      }
     
      const insertFileIntoWord = async (file) => {
        try {
          await Word.run(async (context) => {
            const reader = new FileReader();
       
            reader.onload = async (event) => {
              const arrayBuffer = event.target.result;
              const base64String = arrayBufferToBase64(arrayBuffer);
       
              context.document.body.insertFileFromBase64(base64String, Word.InsertLocation.replace);
              await context.sync();
            };
            reader.readAsArrayBuffer(file);
          });
        } catch (error) {
          console.error("Error inserting Word file:", error);
        }
      };
       
      const arrayBufferToBase64 = (buffer) => {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
        return btoa(binary);
      };
 function getEditableRequests(allRequestItems) {
    const editableRequests = [];
    allRequestItems.forEach((data) => {
      let currentRequestStage = "";
      let currentUserRole = [];
      const currentUserId = CurrentUser?.id;
 
      const Legal_users = data?.Legal_UserId || [];
      const Approvers = data?.AllTaskApproversId || [];
 
      if (currentUserId === data?.AuthorId) {
        currentUserRole.push("Business User");
      }
      if (data?.Status === "Legal Review") {
        currentRequestStage = "Legal Review";
        if (!( data?.["RequestApproval"] === "Completed" && data?.["DraftApproval"] === "Completed" &&
          data?.["Negotiation"] !== "Pending" && data?.["ExecutionApproval"] === "Not Started")) {
          if (Legal_users.includes(currentUserId)) {
            currentUserRole.push("Legal User");
          }
        }
      } else {
        if (data?.["Negotiation"] === "Pending") {
          currentRequestStage = "Negotiation";
        }
        if ( data?.["RequestApproval"] === "Pending" && data?.["Negotiation"] !== "Pending") {
          currentRequestStage = "Business Approval";
          if (Approvers.includes(currentUserId)) {
            currentUserRole.push("Business Approver");
          }
        } else if ( data?.["RequestApproval"] === "Completed" && data?.["Negotiation"] !== "Pending" &&
          data?.["DraftApproval"] === "Not Started") {
          currentRequestStage = "Business Approval";
        } else if ( data?.["DraftApproval"] === "Pending" && data?.["Negotiation"] !== "Pending") {
          currentRequestStage = "Legal Review";
          if (Approvers.includes(currentUserId)) {
            currentUserRole.push("Draft Approver");
          }
        } else if (  data?.["RequestApproval"] === "Completed" && data?.["DraftApproval"] === "Completed" &&
          data?.["Negotiation"] !== "Pending" && data?.["ExecutionApproval"] === "Not Started" ) {
          currentRequestStage = "Legal Review";
        } else if ( data?.["RequestApproval"] === "Completed" && data?.["DraftApproval"] === "Completed" &&
          data?.["ExecutionApproval"] === "Pending"
        ) {
          currentRequestStage = "Execution Approval";
          if (Approvers.includes(currentUserId)) {
            currentUserRole.push("Execution Approver");
          }
        }
      }
 
      const RequestApprovalVal = data?.["RequestApproval"];
      const ExecutionApprovalVal = data?.["ExecutionApproval"];
      const DraftApprovalVal = data?.["DraftApproval"];
 
      const filteredRoles = RequestActions?.filter((e) => {
        return (
          e.RequestStage === currentRequestStage &&
          currentUserRole.includes(e.Role) &&
          e.RequestApproval === RequestApprovalVal &&
          e.DraftApproval === DraftApprovalVal &&
          e.ExecutionApproval === ExecutionApprovalVal
        );
      });
 
      const RequestActionRole = [];
      filteredRoles?.forEach((ele) => {
        RequestActionRole.push(...ele?.RequestAction.split(","));
      });
 
      if (
        RequestActionRole.includes("Edit") ||
        RequestActionRole.includes("Edit Request") ||
        RequestActionRole.includes("Upload Draft")
      ) {
        editableRequests.push(data);
      }
    });
 
    return editableRequests;
  }
 
      const getAllRequestData = async () => {
        try {
          setLoading(true);
          const requestItems = await fetchRequestListData();
          const requestOptions = [];
          const filtredItems = getEditableRequests(requestItems);
          allRequestItems = [...filtredItems];
          filtredItems?.filter(i=>i?.SampleRequest !== 'Yes')?.map((request) => {
            if(request?.File_Name?.includes(".docx")){
                requestOptions.push({
                  ...request,
                    key: request?.Guid_ID,
                    text: request?.Title,
                    value: request?.Guid_ID,
                    label: request?.Title,
                    File_Name:request?.File_Name,
                    Contract_Type:request?.["Contract_Type"].split("|")[0],

                  });
            }
          });
          setAllRequestOpt(requestOptions);
          setTimeout(() => {
            setLoading(false)
          }, 1000);

        } catch (error) {
          console.log(error);
        }
      };
    const getRequestData = async (reqGuid) => {
  
        setRequestLoading(true);
        try {
          const requestItem: any = await fetchRequestData(reqGuid);
    
          const requestData = requestItem[0];

          const counterPartys=JSON.parse(requestData?.Counterparty_Name||"[]")
        const mapCounterpartys=counterPartys?.map((ele)=>ele.OrgName)?.join(", ")
          const requestItemData={
            Title:requestData?.Title,
            Guid_ID:requestData?.Guid_ID,
            Contract_Start_Date:requestData?.Contract_Start_Date,
            Contract_End_Date:requestData?.Contract_End_Date,
            Counterparty_Name:mapCounterpartys,
            Request_Number:requestData?.Request_Number
          }
          setSelectedRequestData(requestData)
          setData(requestItemData)
          const Contracttype = requestData?.Contract_Type ? requestData.Contract_Type.split("|") : "";
          const ContracttypeRowID = Contracttype[0];
            if (
              requestData?.Status === 'Legal Review' ||
              (requestData?.DraftApproval === 'Pending' && requestData?.Negotiation !== 'Pending') ||
              (
                requestData?.RequestApproval === 'Completed' &&
                requestData?.DraftApproval === 'Completed' &&
                requestData?. Negotiation !== 'Pending' &&
                requestData?. ExecutionApproval === 'Not Started'
               )
               ) {
                 setDraftInLegalReview(true)
                } 
          setRequestLoading(false);
        } catch (error) {
          setRequestLoading(false);
          console.log(error);
        }
      }
    function handleTerms() {
      setShow({Terms:true,alternat:false,missingClause:false,summary:false,SendReview:false,AISummary:false})
      setIsTermsDetailsListOpen(true)
    }
    function handleAlternateClause() {
      setShow({Terms:false,alternat:true,missingClause:false,summary:false,SendReview:false,AISummary:false})
      setIsAlterNativeClauseOpen(true)
    }
    function handleMissingClause() {
      setShow({Terms:false,alternat:false,missingClause:true,summary:false,SendReview:false,AISummary:false})
      setIsMissingClauseOpen(true)
    }
    function handleClauseSummary() {
      setShow({Terms:false,alternat:false,missingClause:false,summary:true,SendReview:false,AISummary:false})
      setIsSummaryOpen(true)
    }
    function handleOpenSendReview(){
       setShow({Terms:false,alternat:false,missingClause:false,summary:false,SendReview:true,AISummary:false})
      setisSendReview(true)
    }
    function handleAISummary(){
       setShow({Terms:false,alternat:false,missingClause:false,summary:false,SendReview:false,AISummary:true})
       setIsAISummary(true)
    }

    const saveFile=async ()=>{

      SweetalertPrompt('warning','Are you sure you want to update the file?').then(async (result)=>
        {
          if(result.isConfirmed){
            await replaceFieldValues();
            await saveFiles()
    }
  }) 
}
const getDocumentAsBlob = (): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    Office.context.document.getFileAsync(Office.FileType.Compressed, { sliceSize: 65536 }, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const file = result.value;
        const sliceCount = file.sliceCount;
        const slices: Uint8Array[] = [];

        let getSlice = (index: number) => {
          file.getSliceAsync(index, (sliceResult) => {
            if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
              const sliceData = sliceResult.value.data;
              slices[index] = new Uint8Array(sliceData);

              if (slices.filter(Boolean).length === sliceCount) {
                file.closeAsync();
                const blob = new Blob(slices, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                resolve(blob);
              } else {
                getSlice(index + 1);
              }
            } else {
              reject(sliceResult.error.message);
            }
          });
        };

        getSlice(0);
      } else {
        reject(result.error.message);
      }
    });
  });
};

    const saveFiles=async()=>{
      setspinnerLoading(true)
      const SummaryDetails = {
            SummaryData: summaryState.summary,
            SummaryCreatedOn: new Date(),
            DraftSummaryVersion: LatestDraftversions?.[0],
            SummaryGeneratedFrom: AzureAI?.AzureOpenAIToggle ? 'Azure Ai' : 'Copilot Ai'
      }
      const finaltemp = {ContractSummary :JSON.stringify(SummaryDetails)}
      updateListItem('CLM365Request', finaltemp, requestDetails?.ID)
      const fullUrl = Office.context.document.url;
      const serverRelativeUrl = fullUrl ? new URL(fullUrl).pathname : null;

      const filePath = encodeURIComponent(serverRelativeUrl);
      const curl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${filePath}')/$value`;
      try{
        const token = localStorage.getItem("CurrentToken");
        const responseBlob:any= await axios({
          method: 'get',
          url: curl,
          headers: {
            'Authorization': `Bearer ${token}`,
          },
          responseType: 'blob'
        })
   
         if(responseBlob?.data){
            const fileData = new File([responseBlob?.data], "template.docx", {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          downloadDocx(fileData,requestDetails['File_Name'])
        }
      }catch(error){
         const status = error?.response?.status;
          if ([401, 402, 403].includes(status)) {
          return await handleTokenExpiration(saveFiles);
        } else {
        console.log(error)
      }
     }
    }

    
      async function downloadDocx(blob, fileName) {
        const file = new File([blob], fileName, {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        const blobNew = await getDocumentAsBlob();
        saveDraftFile(fileName,blobNew)
        // saveDraftFile(fileName,file) 
    }
    async function saveDraftFile(fileName, fileContent) {
      const SiteURL = localStorage.getItem("SiteURL");
      const token = localStorage.getItem("CurrentToken");
      if (!fileName) return;
    
      let url = `${SiteURL}/_api/web/getFolderByServerRelativeUrl('CLM365RequestDraft')/files/add(url='${fileName}',overwrite=true)`;
    
      try {
        await axios.post(url, fileContent, {
          headers: {
            Accept: "application/json;odata=verbose",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/octet-stream"
          }
        });
        setspinnerLoading(false);
        SweetAlertsEdit("success", "File saved successfully");
        
          // setShow({ Terms: false, alternat: false, missingClause: false })
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
//     React.useEffect(()=>{
// // console.log(show,'components to show')
// },[show])
   return (
    <div id='SweetalertEditDraftss' style={{position:'relative'}}>

    {!show.Terms && !show.alternat && !show.missingClause && !show.summary&&!show?.SendReview && !show?.AISummary? (
  <>
    {loading ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "70vh",
        textAlign: "center",
      }}
    >
      <Spinner label="Please wait..."  size={SpinnerSize.small} />
    </div>
  ) : (
    allRequestOpt?.length > 0 ? (
      <div>
      <div>
        {ShowAllReq && (
        <>
        <Label>Requests</Label>
         <Select
          placeholder={"Select a request"}
          options={allRequestOpt}
          value={selectedRequest != undefined &&
            selectedRequest != null &&
            allRequestOpt?.filter(({ key }) => key === selectedRequest)}
          isSearchable={true}
          onChange={(select) => onChangeRequest(select,'Select')}
          styles={customStyles}
          theme={SelectTheme}
          minMenuHeight={140}
          maxMenuHeight={220} />
          </>)}

        {selectedRequest && !RequestLoading ? ( <>  <div>
          <Label>Title</Label>
          <TextField
            name="title"
            placeholder={"Enter title"}
            value={data?.Title}
            disabled />
        </div>
          <div>
            <Label>Request Number</Label>
            <TextField
              name="RequestNumber"
              placeholder={"Enter request number"}
              value={data?.Request_Number}
              disabled />
          </div>
          {/* <div >
        <Label>Counterparty Name</Label>
          <TextField
            name="CounterpartyName"
            placeholder={""}
            value={data?.Counterparty_Name}
            disabled
          />
        </div>
        <div >
        <Label>Contract Start Date</Label>
          <DatePicker    value={data?.Contract_Start_Date?new Date(data?.Contract_Start_Date):null}  formatDate={onFormatDate} disabled/>
    
        </div>
        <div >
        <Label>Contract End Date</Label>
        <DatePicker  value={data?.Contract_End_Date?new Date(data?.Contract_End_Date):null}   formatDate={onFormatDate} disabled/>
        </div> */}
        </> ) : null}
      </div>
      {(CurrentUser?.userRole !== 'Legal Head' || CurrentUser?.userRole !== 'Legal User') && (<div>
       { (AzureAI?.Endpoint && AzureAI?.DeploymentName && AzureAI?.APIkey && AzureAI?.AzureOpenAIToggle || Copilot?.CopilotToggle ==='Yes')?<div style={{ marginTop: "10px" }} className="CardDivContainer" onClick={handleAISummary}>
        <div className="ms_card_container">
          <div className="card_icon">
            <LayerRegular />
          </div>
          <div className="card_contnet">
            <Label style={{padding:"unset", display:'flex', justifyContent:'space-between', marginBottom:'-6px'}} className={`${"card_heading"} ${'ai_card'}`}>Contract Summary           
              <img src={AiStars} alt="AI Stars" width={25} height={25} /></Label>
            <Label style={{fontWeight:"400"}} className="card_description">
              Generate AI-powered summary of the contract using the assistant.
            </Label>
          </div>
        </div>
      </div>:null}
      <div className="CardDivContainer" onClick={handleTerms}>
        <div className="ms_card_container">
          <div className="card_icon">
            <LayerRegular />
          </div>
          <div className="card_contnet">
            <Label style={{padding:"unset"}} className="card_heading">Terms</Label>
            <Label style={{fontWeight:"400"}} className="card_description">
              Select terms from the options provided and insert them into the document.
            </Label>
          </div>
        </div>
      </div>
         <div className="CardDivContainer" onClick={handleAlternateClause}>
              <div className="ms_card_container">
                <div className="card_icon">
                  <LayerRegular />
                </div>
                <div className="card_contnet">
                  <Label style={{padding:"unset"}} className={`${"card_heading"} ${'ai_card'}`}>Alternative Clauses
                   {isAIEnabled?<img src={AiStars} alt="AI Stars" width={25} height={25} />:""}
                  </Label>
                  <Label style={{fontWeight:"400"}} className="card_description">
                    {isAIEnabled?"Select clause from the contract and use AI to generate an alternative for that clause.":"Select a clause from the contract and generate an alternative of that clause."}
                  </Label>
                </div>
              </div>
            </div>
    {(AzureAI?.Endpoint && AzureAI?.DeploymentName && AzureAI?.APIkey && AzureAI?.AzureOpenAIToggle || Copilot?.CopilotToggle ==='Yes') ? (
          <>

            <div className="CardDivContainer" onClick={handleMissingClause}>
              <div className="ms_card_container">
                <div className="card_icon">
                  <LayerRegular />
                </div>
                <div className="card_contnet">
                  <Label className={`${"card_heading"} ${'ai_card'}`}>Missing Clauses
                  <img src={AiStars} alt="AI Stars" width={25} height={25} />
                  </Label>
                  <Label style={{fontWeight:"400"}} className="card_description">
                    Identify missing clauses from the contract using AI.
                  </Label>
                </div>
              </div>
            </div>
            <div className="CardDivContainer" onClick={handleClauseSummary}>
              <div className="ms_card_container">
                <div className="card_icon">
                  <LayerRegular />
                </div>
                <div className="card_contnet">
                  <Label className={`${'card_heading'} ${'ai_card'}`}>Clause Summary
                  <img src={AiStars} alt="AI Stars" width={25} height={25} />
                  </Label>
                  <Label style={{fontWeight:"400"}} className="card_description">
                    Get the summary for the clauses from the contract.
                  </Label>
                </div>
              </div>
            </div>             
             </>
            ) : null}
           {draftInLegalReview&&(<div className="CardDivContainer" onClick={handleOpenSendReview}>
              <div className="ms_card_container">
                <div className="card_icon">
                  <CommentAdd20Regular/>
                </div>
                <div className="card_contnet">
                  <Label style={{padding:"unset"}}className="card_heading">Send Review</Label>
                  <Label style={{fontWeight:"400"}} className="card_description">
                  Send Review lets you select text and instantly add a comment for feedback or collaboration</Label>
                </div>
              </div>
            </div>)}
          </div>)}
      </div>
    ) : (
      <div
        style={{
          textAlign: "center",
          padding: "85px 20px",
          background: "var(--lightThemeBGcolorWhite)",
          borderRadius: "12px",
        }}
      >
        <h3 style={{ color: "var(--layoutTextColor)", marginTop: "20px" }}>
          No Editable Requests Found
        </h3>
        <p style={{ color: "gray", fontSize: "15px" }}>
          Sorry, you currently don’t have any editable requests. Please check again later or contact your administrator for assistance.
        </p>
      </div>
    )
  )}
  </> ) : 
    show.Terms ?
    (
      <div> <Terms requestDetails={requestDetails} type={"Draft"} /></div>) 
      : show.alternat ? (<div> <AlternateClauseAI /></div>) 
      : show.missingClause ? (<div> <MissingClauseExtractor /></div> ) 
      : show.summary ? (<div> <ClauseSummary/></div>)
      : show?.SendReview?(<div><SendReview FileName={draftFileName} RequestListData={selectedRequestData}/></div>)
      : show?.AISummary ? (<div><ContractSummary RequestData={selectedRequestData} summaryState={summaryState} setSummaryState={setSummaryState}/></div>):null
       }
   <Modal
      isOpen={spinnerLoading}
      styles={{ main: { maxWidth: 300, minWidth: 230, minHeight: "100px", display: "flex", justifyContent: "center"}}}>
          <Spinner label="Updating your file. Please wait..."  size={SpinnerSize.small} style={{marginTop:'25px'}}/>
        </Modal>
     {!show.Terms && !show.alternat && !show.missingClause && !show.summary &&!show?.SendReview && !show?.AISummary && !spinnerLoading && allRequestOpt?.length > 0? <><Save24Regular 
         className='saveButton'  
         title="Save Draft" 
         onClick={saveFile}
         /> 
         <TaskListLtr24Regular
          className='previewButton' 
          title="View all requests"
          onClick={()=>setShowAllReq(!ShowAllReq)}
          /></>:null}

        </div>
  )
}

export default EditDraft